import { useMemo } from 'react';

import { useTheme } from '@mui/material';

import type { ExtendedOptions } from '@/components/Chart/types/highcharts';
import { CHART_HEIGHT } from '@/features/DataHub/constants/charts';

const usePreviewOptions = (
  baseOptions: ExtendedOptions | undefined,
  textColor?: string,
  backgroundColor?: string
): ExtendedOptions | undefined => {
  const theme = useTheme();
  textColor = textColor ? theme.palette.background.paper : theme.palette.text.primary;
  backgroundColor = backgroundColor ? theme.palette.text.primary : theme.palette.background.paper;
  return useMemo(() => {
    if (!baseOptions) return undefined;

    return {
      ...baseOptions,
      chart: {
        ...baseOptions.chart,
        backgroundColor: backgroundColor,
        height: CHART_HEIGHT
      },
      navigator: {
        enabled: false
      },
      rangeSelector: {
        enabled: false
      },
      legend: {
        enabled: true,
        itemStyle: {
          color: textColor,
          fontSize: '0.8em',
          textOverflow: 'ellipsis'
        }
      },
      exporting: {
        ...baseOptions.exporting,
        chartOptions: {
          ...baseOptions.exporting?.chartOptions,
          legend: {
            ...baseOptions.exporting?.chartOptions?.legend,
            itemStyle: {
              color: textColor,
              fontSize: '0.8em',
              textOverflow: 'ellipsis'
            }
          }
        }
      },
      scrollbar: {
        enabled: false
      }
    };
  }, [baseOptions, textColor, backgroundColor]);
};

export default usePreviewOptions;
